import React, { useEffect } from 'react';
import Skills from './Skills';
import Experience from './Experience';
import Education from './Education';
import Projects from './Projects';
import Profile from './Profile';
import SoftSkills from './SoftSkills';
import Hobbies from './Hoppies';

const PersonalInfo = () => {

  useEffect(() => {
    const meters = document.querySelectorAll('.meter-bar');
    setTimeout(() => {
      meters.forEach(meter => {
        const value = meter.getAttribute('aria-valuenow');
        meter.style.width = `${value}%`;
      });
    }, 100); // Delay to ensure the transition effect is applied
  }, []);





  return (
    <>

      <div
        className={`relative showAnimation min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-purple-600 via-sky-600 to-blue-900 dark:from-gray-600 dark:via-gray-900 dark:to-black text-white overflow-hidden duration-500`}
      >

        <div className="absolute  pointer-events-none top-0 left-0 w-full h-full overflow-hidden z-10">
          <div className="diamond"></div>
          <div className="diamond diamond-2"></div>
          <div className="diamond diamond-3"></div>
          <div className="diamond diamond-4"></div>
          <div className="diamond diamond-5"></div>
          <div className="diamond diamond-6 "></div>
        </div>
        <div className="p-2">
          <div className='flex  flex-col sm:flex-row h-full min-h-screen ' >
            {/* first div on the left of the screen */}
            <div className='flex pl-1  flex-col sm:w-1/4 transition-width duration-1000 w-full min-w-fit pr-3  min-h-screen sm:border-r-2 border-blue-500 dark:border-blue-300 '>

              {/* contacts and comunication */}
              <h2 className="text-2xl w-full font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Personal Information</h2>
              <Profile />
              {/* soft skills */}
              <h2 className="text-2xl mt-10 w-full font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Soft Skills</h2>
              <SoftSkills />
              {/* eduction */}
              <h2 className="text-2xl w-full mt-10 font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Education</h2>
              <Education />
              <h2 className="text-2xl w-full mt-10 font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Hobbies</h2>
              <Hobbies/>
            </div>
            {/* second div on the right or bottom of the screen */}
            <div className='flex flex-col  flex-grow z-20  pl-3   '>
              <Skills />
              <Experience />
              <Projects />
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default PersonalInfo;
